import { render, staticRenderFns } from "./SwitchClub.vue?vue&type=template&id=67d43c0c&"
import script from "./SwitchClub.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SwitchClub.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d43c0c')) {
      api.createRecord('67d43c0c', component.options)
    } else {
      api.reload('67d43c0c', component.options)
    }
    module.hot.accept("./SwitchClub.vue?vue&type=template&id=67d43c0c&", function () {
      api.rerender('67d43c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/SwitchClub/SwitchClub.vue"
export default component.exports